import { useMemo } from "react";

import useTreeRow from "./useTreeRow";

const ProjectTreeRowName = ({ rowObj, fontSize, callbacks }) => {
	const { handleClick } = useTreeRow();

	const rowTitle = useMemo(() => {
		if (rowObj?.date_upload) {
			return `${rowObj.innertext} [Загружено: ${rowObj.date_upload}]`;
		} else {
			return rowObj.innertext;
		}
	}, [rowObj?.innertext, rowObj?.date_upload]);

	return (
		<span
			className="project-tree-row-name"
			style={{ fontSize: fontSize }}
			title={rowTitle}
			onClick={(event) => handleClick({ rowObj: rowObj, event: event })}
			onContextMenu={(event) => {
				handleClick({ rowObj: rowObj, event: event });
				callbacks.openContextMenu({ clickedRow: rowObj, event: event });
			}}
		>
			{rowObj.innertext}
		</span>
	);
};

export default ProjectTreeRowName;
